"use strict";
import { Type, ready, addCustomEvent, pos, Dom, Runtime } from "main.core";
import { VSCore } from "vsbx.core";
const loadFancybox = () => {
 if (document.querySelectorAll("[data-fancybox]").length && typeof Fancybox == 'undefined') {
  Runtime.loadExtension("vsbx.ui.fancybox.start").then((exports) => {
   if (Type.isFunction(exports.startFancybox)) {
    exports.startFancybox();
   } else {
    exports.VS.startFancybox();
   }
  });
 }
}
const loadJSLibraries = () => {
 loadFancybox();
 let p = document.querySelectorAll('[data-parallax="true"]:not(.init-scene-parallax)');
 if (p.length) {
  Runtime.loadExtension("vsbx.ui.parallax").then((exports) => {
   p.forEach(function (scene) {
    Dom.addClass(scene, 'init-scene-parallax');
    new Parallax(scene, { relativeInput: true });
   });
  });
 }
 let aos = document.querySelectorAll("[data-aos]");
 if (aos.length) {
  Runtime.loadExtension("vsbx.ui.aos").then((exports) => {
   AOS.init({
    once: true,
   });
  });
 }
 let btnShare = document.querySelectorAll("[data-modal]");
 if (btnShare.length && !VS.FormUtil) {
  Runtime.loadExtension("vsbx.formutil").then((exports) => { });
 }
 let btnPrint = document.querySelectorAll(".btn-print:not(.init-btn-print)");
 if (btnPrint.length) {
  class printDocument {
   print(url) {
    let iframe = this._printIframe;
    if (!this._printIframe) {
     iframe = this._printIframe = document.createElement('iframe');
     document.body.appendChild(iframe);
     iframe.style.display = 'none';
     iframe.onload = function () {
      setTimeout(function () {
       iframe.focus();
       iframe.contentWindow.print();
      }, 1);
     };
    }
    iframe.src = url;
   }
  }
  let printDoc = new printDocument();
  btnPrint.forEach((el) => {
   Dom.addClass(el, 'init-btn-print');
   el.addEventListener('click', (e) => {
    e.preventDefault();
    if (el.dataset.type == 'doc') {
     printDoc.print(el.href);
    } else if (el.dataset.type == 'page') {
     window.print();
    } else {
     Runtime.loadExtension("vsbx.ui.print").then((exports) => {
      let url = el.href;
      if (el.dataset.target) {
       url = el.dataset.target;
      }
      let params = { printable: url, type: el.dataset.type ? el.dataset.type : 'pdf', showModal: true }
      if (el.dataset.type == 'html') {
       params.css = [
        '/local/templates/main/layout/css/style.css',
        '/local/templates/main/styles.css',
        '/local/templates/main/template_styles.css',
        '/local/templates/main/css/print.css'
       ];
       params.scanStyles = false;
       params.header = '<h1 class="custom-h3">' + document.title + ' <span style="font-size: 10px">' + location.href + '</span></h1>';
      }
      VS.printJS(params);
     });
    }
   });
  });

 }
 let tippyEls = document.querySelectorAll("[data-tippy]");
 if (tippyEls.length) {
  Runtime.loadExtension("vsbx.ui.tippy").then((exports) => {
   tippy("[data-tippy]", {
    content(reference) {
     const id = reference.getAttribute("data-tippy");
     if (id == '') {
      return reference.getAttribute("data-title");
     }
     const template = document.getElementById(id);
     return template?.innerHTML || "";
    },
    theme: "custom",
    allowHTML: true,
   });
  });
 }
 const counterBlocks = document.querySelectorAll("[data-num-animate]");
 if (counterBlocks.length) {
  // Настройки анимации
  const baseSpeed = 1000; // Общая длительность анимации в ms
  const minSteps = 30; // Минимальное количество шагов анимации
  const counters = VSCore.getGlobalConfig('COUNTERS');
  const animateCounter = (counter) => {
   let target, current = 0;
   let suffix = counter.getAttribute("data-suffix")
    ? counter.getAttribute("data-suffix")
    : "";
   if (counter.getAttribute("data-num-animate-key") && counters[counter.getAttribute("data-num-animate-key")]) {
    let v = counters[counter.getAttribute("data-num-animate-key")];
    if (counters[counter.getAttribute("data-num-animate-key") + '_MIN']) {
     v = counters[counter.getAttribute("data-num-animate-key") + '_MIN'];
    }
    target = VSCore.utilNumber.MathFloor10(v, counter.getAttribute("data-num-animate-key-exp"));
    if (v > target) suffix = '+';
   } else {
    target = parseInt(
     counter.getAttribute("data-num-animate-count"),
     10
    );
   }
   // Рассчитываем оптимальное количество шагов
   const maxStep = target < 2000 ? target : target / 4;
   const steps = Math.max(minSteps, maxStep);
   const increment = target / steps;
   const intervalTime = baseSpeed / steps;

   let time;
   const update = () => {
    current = Math.min(current + increment, target);
    counter.textContent = Math.round(current) + suffix;

    if (current < target) {
     clearTimeout(time);
     time = setTimeout(update, intervalTime);
    }
   };
   update();
  };

  const observer = new IntersectionObserver(
   (entries) => {
    entries.forEach((entry) => {
     if (entry.isIntersecting) {
      const counters = entry.target.querySelectorAll(
       "[data-num-animate-count]"
      );
      counters.forEach(animateCounter);
      observer.unobserve(entry.target);
     }
    });
   },
   { threshold: 0.3 }
  );
  counterBlocks.forEach((block) => observer.observe(block));
 }
}
addCustomEvent("onAjaxSuccess", function (e, d) {
 if (
  d &&
  d.url &&
  d.url.indexOf("bxajaxid") > -1 &&
  d.url.indexOf("lazyitem") == -1
 ) {
  setTimeout(function () {
   var obNode = document.querySelector("h1"); // BX(node);
   if (obNode && obNode.scrollIntoView) obNode.scrollIntoView(true);
   else {
    var params = {
     top: 0,
     behavior: "auto",
    };
    if (obNode) {
     var arNodePos = pos(obNode);
     params.top = arNodePos.top;
     params.left = arNodePos.left;
    }
    window.scrollTo(params);
   }
  }, 200);
 }
 setTimeout(loadJSLibraries, 500);
});
// запрет резать теги в редакторе
addCustomEvent("OnEditorInitedBefore", function (toolbar) {
 var _this = this;
 //debugger;
 addCustomEvent(
  this,
  "OnGetParseRules",
  BX.proxy(function () {
   _this.rules.tags.span = {};
   _this.rules.tags.svg = {};
   _this.rules.tags.use = {};
   _this.rules.tags.path = {};
   _this.rules.tags.g = {};
   _this.rules.tags.rect = {};
  }, this)
 );
});
ready(function () {
 loadJSLibraries();

 VSCore.scrollHash(location.hash, true);
 document.addEventListener("click", function (e) {
  let a = e.target.closest('a[href*="#"]');
  if (a) {
   if (a.hash !== "" && a.pathname === location.pathname) {
    e.preventDefault();
    VSCore.scrollHash(
     a.hash,
     true,
     BX.hasClass(e.currentTarget, "use-anim")
    );
   } else if (a.getAttribute("href") === "#") {
    e.preventDefault();
   }
  }
 });
 let div_loading = document.querySelector("#div_loading");
 if (div_loading) {
  setTimeout(function () {
   var easing = new BX.easing({
    duration: 800,
    start: { opacity: 100 },
    finish: { opacity: 0 },
    transition: BX.easing.transitions.quart,
    step: function (state) {
     div_loading.style.opacity = state.opacity / 100;
    },
    complete: function () {
     Dom.remove(div_loading);
    },
   });
   easing.animate();
  }, 200);
 }
});
